import gql from 'graphql-tag'
import { EMPLOYEE_DATA, MONTHLY_PAYROLL_ITEM } from './data'

export const CREATE = gql`
  mutation createMonthlyPayroll($input: MonthlyPayrollInput!) {
    createMonthlyPayroll(input: $input) {
      id
    }
  }
`
export const GENERATE = gql`
  mutation generateMonthlyPayroll($month: Int!, $year: Int!) {
    generateMonthlyPayroll(month: $month, year: $year) {
      employee {
        ${EMPLOYEE_DATA}
      }
      ${MONTHLY_PAYROLL_ITEM}
    }
  }
`

export const UPDATE_PAYROLL = gql`
  mutation updateMonthlyPayroll($id: ID!, $input: MonthlyPayrollInput!, $is_refresh: Boolean!) {
    updateMonthlyPayroll(id: $id, input: $input, is_refresh: $is_refresh) {
      id
    }
  }
`

export const DELETE_PAYROLL = gql`
  mutation deleteMonthlyPayroll ($id: ID! ) {
    deleteMonthlyPayroll (id: $id) {
      id
    }
  }
`
